import React from 'react'
import PropTypes from 'prop-types'
import { Sidebar, Date } from './ArticleSidebar.style'
import SocialShare from '../SocialShare'

const ArticleSidebar = ({ publishDate, pageURL }) => (
  <Sidebar>
    <Date>{publishDate}</Date>
    <SocialShare mobileOnly={false} pageURL={pageURL} />
  </Sidebar>
)

ArticleSidebar.propTypes = {
  publishDate: PropTypes.string.isRequired,
  pageURL: PropTypes.string.isRequired,
}

export default ArticleSidebar
